export function routes($stateProvider) {
    $stateProvider
        .state('app.pagamentos', {
        url: '/pagamentos',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.pagamentos.list', {
        url: '?{page:int}&{limit:int}&sortBy&filter',
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        },
        title: 'Pagamentos',
        template: '<core-pagamento-list></core-pagamento-list>',
        role: ['pagamentosVisualizar']
    });
}
routes.$inject = ['$stateProvider'];
